<template>
    <div>
        <div class="tabs px-4 grid grid-cols-12 max-w-1192">
            <a
                v-for="tab in tabs"
                :key="`tab-${tab.name}`"
                href="#"
                :class="{active: activeTab(tab.name)}"
                class="tab c-btn col-span-4 block bg-transparent text-darker-200 font-semibold text-[20px] leading-[27px] border border-darker-200 border-l-0 rounded-[0px] first:border-l"
                @click.prevent="handleSelectTab(tab)"
            >
                {{ tab.title }}
            </a>
        </div>

        <div class="tabs-multi max-w-1432 px-4">
            <Multiselect
                name="type"
                track-by="title"
                valueProp="name"
                label="title"
                class='custom-multiselect'
                :searchable="false"
                :options="tabs"
                :can-clear="false"
                placeholder="Не выбрано"
                noResultsText="Не найдено"
                noOptionsText="Не найдено"
                @select="handleSelectTab"
                v-model="multiTab"
            />
        </div>

        <div class="max-w-1192 text-center traffic mx-auto">
            <a target="_blank" href="https://www.gipsyteam.ru/pokerrumy/traffic/min">ЗАМЕРЫ ТРАФИКА<span></span></a>
        </div>

        <div class="max-w-1432 page-content-wrap px-4 mx-auto filter">
            <div class="filter-name"><img src="/images/website/filter.svg"><span class="text">ФИЛЬТР:</span></div>
            <div v-if="tags" class="tags">
                <div v-for="tag in tags" :key="tag.id" class="tag">
                    <label class="checkbox-label">
                        <input
                            type="checkbox"
                            :checked="selectedTag === tag.id"
                            class="checkbox-input"
                            @change="handleFilter(tag.id)"
                        >
                        <span class="checkbox-custom"></span>
                        <span class="text">{{ tag.title }}</span>
                    </label>
                </div>
            </div>
        </div>

        <div v-if="content[multiTab] && content[multiTab].content" class="max-w-1432 page-content-wrap px-4 mx-auto">
            <div class="content-text" v-html="content[multiTab].content"></div>
        </div>

        <WebsiteBlocks v-if="content[multiTab] && content[multiTab].blocks" :blocks="filteredBlocks"/>
    </div>
</template>

<script>
import WebsiteBlocks from "../../../components/blocks/WebsiteBlocks";
import Multiselect from '@vueform/multiselect';

export default {
    components: {WebsiteBlocks, Multiselect},
    data() {
        return {
            tabs: [
                {
                    title: 'Классические румы',
                    name: 'classic',
                },
                {
                    title: 'Браузерные румы',
                    name: 'browserrooms',
                },
                {
                    title: 'Приложения',
                    name: 'apps',
                },
            ],
            multiTab: null,
            content: {
                classic: null,
                browserrooms: null,
                apps: null,
            },
            tags: null,
            selectedTag: null,
        }
    },
    computed: {
        filteredBlocks() {
            if (!this.content[this.multiTab] || !this.content[this.multiTab].blocks) {
                return [];
            }

            // Если не выбран тег - показываем все блоки
            if (!this.selectedTag) {
                return this.content[this.multiTab].blocks;
            }

            // Фильтруем блоки по выбранному тегу
            return this.content[this.multiTab].blocks.filter(block => {
                if (!block.tags || !Array.isArray(block.tags)) {
                    return false;
                }

                // Блок должен содержать выбранный тег
                return block.tags.some(tag => tag.id === this.selectedTag);
            });
        }
    },
    methods: {
        async fetchContent(name) {
            try {
                const {data} = await this.axios.get(`/content/${name}`);

                if (data) {
                    this.content[name] = data.data;
                }
            } catch (ex) {
                console.log('cant fetch content: ', ex);
            }
        },
        async fetchTags() {
            try {
                const {data} = await this.axios.get(`/content/tags`);

                if (data) {
                    this.tags = data.tags;
                }
            } catch (ex) {
                console.log('cant fetch tags: ', ex);
            }
        },
        handleSelectTab(tab) {
            const name = typeof tab === 'object' ? tab.name : tab;
            this.multiTab = name;
            this.$router.push(`/#${name}`);
            this.selectedTags = null;
        },
        activeTab(tab) {
            return tab === this.multiTab;
        },
        handleFilter(tagId) {
            // Если кликаем на уже выбранный тег - снимаем выбор
            if (this.selectedTag === tagId) {
                this.selectedTag = null;
            } else {
                // Иначе выбираем новый тег (старый автоматически сбрасывается)
                this.selectedTag = tagId;
            }
        }
    },
    async created() {
        await this.fetchContent('classic');
        await this.fetchContent('browserrooms');
        await this.fetchContent('apps');
        await this.fetchTags();
    },
    mounted() {
        this.multiTab = this.$route.hash ? this.$route.hash.split('#')[1] : 'classic';
    },
}
</script>
<style scoped lang='scss'>
.tabs {
    margin: 60px auto 32px;
}

.tabs-multi {
    display: none;
}

.tab {
    &:hover,
    &:focus {
        @apply bg-darker-200 text-white text-opacity-75;
    }

    &:hover,
    &:focus,
    &.active {
        @apply bg-darker-200 text-white;
    }

    &.active {
        pointer-events: none;
    }
}

.traffic a {
    font-size: 20px;
    font-weight: 700;
    color: #E93851;
    position: relative;
    padding: 0 22px;
    //border-bottom: 1px solid #E93851;

    span {
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: #E93851;
        transition: all 0.3s;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
    }
    &:after, &:before {
        content: '';
        position: absolute;
        width: 18px;
        height: 18px;
        background-image: url(/images/website/rhombus.svg) ;
        background-repeat: no-repeat;
        background-position: center center;
        top: 50%;
        transform: translateY(-50%);
    }
    &:before {
        left: 0;
    }
    &:after {
        right: 0;
    }
    
    &:hover {
        span {
            width: 0;
        }
    }
}

.filter {
    margin: 69px auto 8px;
    display: flex;
    align-items: center;

    .text {
        font-size: 14px;
        font-weight: 700;
        color: #808080;
        text-transform: uppercase;
    }

    .filter-name {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        img {
            width: 14px;
            height: 14px;
            margin-right: 7px;
        }
        .text {
            color: #000;
        }
    }

    .tags {
        display: flex;
        flex-wrap: wrap;
    }

    .tag {
        margin-left: 30px;
        margin-bottom: 15px;
        .checkbox-label {
            display: flex;
            align-items: center;
            cursor: pointer;
            transition: all 0.3s;

            .checkbox-input {
                display: none;

                &:checked + .checkbox-custom {
                    &::after {
                        content: '';
                        position: absolute;
                        background-color: #616161;
                        left: 3px;
                        top: 3px;
                        width: 18px;
                        height: 18px;
                    }
                }

                &:checked ~ .text {
                    color: #000000;
                }
            }

            .checkbox-custom {
                position: relative;
                width: 26px;
                height: 26px;
                border: 1px solid #616161;
                transition: all 0.3s;
                margin-right: 15px;
            }
        }
    }
}

@media all and (max-width: 860px) {
    .tabs {
        display: none;
    }

    .tabs-multi {
        display: block;
        margin: 44px auto 24px;
    }

    .custom-multiselect {
        max-width: 360px;
        color: #000;
        border-color: #202020;
        font-family: "Gilroy", sans-serif;
        font-size: 18px;
        line-height: 22px;

        &::v-deep {
            .multiselect-wrapper {
                @apply bg-darker-200;
            }

            .multiselect-search::placeholder,
            .multiselect-search {
                @apply bg-darker-200 text-white;
            }

            .multiselect-caret,
            .multiselect-clear-icon {
                background-color: #fff;
            }

            .multiselect-option.is-selected {
                background-color: #E70020;
            }

            .multiselect-dropdown {
                background-color: #202020;
                color: #fff;
            }

            .multiselect-option {
                border-bottom: 1px solid #fff;

                &:hover,
                &:focus {
                    cursor: pointer;
                    transition: all .3s ease;
                    background-color: rgba(#E70020, 0.9);
                    color: #fff;
                }

                &:last-child {
                    border-bottom: 0;
                }
            }
        }
    }
}
</style>
